import { Link } from 'react-router-dom';

const features = [
  {
    icon: 'ri-guide-line',
    title: '访问指引',
    description: '提供 http //www.17c/ 完整访问指南，包括浏览器推荐、网络优化等实用技巧。',
    href: '/category/guide',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全保障',
    description: '多层安全防护体系，数据加密传输，全方位保护您的账号和隐私安全。',
    href: '/article/security-features',
  },
  {
    icon: 'ri-user-add-line',
    title: '注册登录',
    description: '简洁的注册流程，多种登录方式，快速上手使用 17c 平台各项服务。',
    href: '/article/register-login',
  },
  {
    icon: 'ri-dashboard-line',
    title: '智能数据管理',
    description: '强大的数据管理能力，支持批量导入导出、智能分类和可视化展示。',
    href: '/article/platform-overview',
  },
  {
    icon: 'ri-team-line',
    title: '协同办公',
    description: '内置协同办公工具，支持多人实时协作，提升团队工作效率。',
    href: '/article/platform-overview',
  },
  {
    icon: 'ri-bar-chart-box-line',
    title: '智能分析',
    description: '先进分析引擎，自定义报表生成、趋势预测，助力科学决策。',
    href: '/article/platform-overview',
  },
];

export default function FeatureCards() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-700 mb-4">
            平台功能
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            为什么选择 17c 平台
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto leading-relaxed">
            从访问入口到功能使用，我们为您提供全方位的数字化服务支持
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feature, index) => (
            <Link
              key={index}
              to={feature.href}
              className="group p-6 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-300/50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-900 mb-2 text-base">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}